import moment from 'moment';
import { Moment } from 'moment';

export class Formatting {
  static toDecimalNumberWithTwoDecimals(
    amount: string,
    replaceSeparator: boolean,
    decimalValue: string,
  ) {
    if (!amount) {
      return '';
    }
    const amountString = amount.toString();
    // From API the value has the form 123 or 123.40 or 123.4 or or 123.45; it will be changed into 123,00 or 123,40 or 123,45
    if (replaceSeparator) {
      return amountString.indexOf('.') === -1
        ? amountString.concat(`,00`)
        : amountString.indexOf('.') === amountString.length - 2
          ? amountString.concat(`0`).replace('.', ',')
          : amountString.replace('.', ',');
    }
    // mask formatting
    let value = '';

    if (amountString.indexOf(',') === amountString.length - 1) {
      value = amountString.concat(`${decimalValue}0`);
    } else if (
      amountString.indexOf(',') > -1 &&
      amountString.indexOf(',') === amountString.length - 2
    ) {
      value = amountString.concat(`${decimalValue}`);
    } else {
      value = amountString;
    }

    return value;
  }

  public static toSimpleDecimalNumber(
    amount: string,
    replaceSeparator: boolean,
  ) {
    if (!amount) {
      return '';
    }
    const amountString = amount.toString();
    // From API the value has the form 123 or 123.40 or 123.4; it will be changed into 123,40
    if (replaceSeparator) {
      return amountString.indexOf('.') === -1
        ? amountString.concat(',00')
        : amountString.indexOf('.') === amountString.length - 2
          ? amountString.concat('0').replace('.', ',')
          : amountString.replace('.', ',');
    }
    // mask formatting
    return amountString.indexOf(',') === amountString.length - 1
      ? amountString.concat('00')
      : amountString.indexOf(',') > -1 &&
          amountString.indexOf(',') === amountString.length - 2
        ? amountString.concat('0')
        : amountString;
  }

  static toDecimalNumberWithOneDecimal(
    amount: string,
    replaceSeparator: boolean,
    decimalValue: string,
  ) {
    if (!amount) {
      return '';
    }
    const amountString = amount.toString();
    // From API the value has the form 123 or 123.4 ; it will be changed into 123,0 or 123,4
    if (replaceSeparator) {
      return amountString.indexOf('.') === -2
        ? amountString.concat(`,${decimalValue}`)
        : amountString.replace('.', ',');
    }
    // mask formatting
    return amountString.indexOf(',') === amountString.length - 1
      ? amountString.concat(`${decimalValue}`)
      : amountString;
  }

  static toDateWithNoTimezone(date: Moment): Moment {
    if (!date || !date.isValid) {
      return date;
    }
    return moment(date).add(date.utcOffset(), 'm').utc();
  }

  static toSubstringFormatText(text: string, length: number): string | void {
    if (!text) {
      return;
    }
    return text.length <= 45 ? text : text.substr(0, length) + ' [...]';
  }
}
